import {Component, Vue} from 'vue-property-decorator'
import {InputElement} from "@/components/lib/models";

@Component
class validateFormMixin extends Vue {

  protected form: Object = {}
  protected error: string = ''
  protected refs(): { [key: string]: Vue | Element | Vue[] | Element[] } {
    return {};
  }

  get fields(): any[] {
    return Object.keys(this.form);
  }

  protected clearFields(): void {
    this.fields.forEach(field => {
      let ref = this.refs()[field] as any;
      if (ref) {
        ref.reset();
      }
    });
  }

  protected validateForm(): boolean {
    let validity = !!this.form;
    if (validity) {
      this.fields.forEach(field => {
        let ref = this.refs()[field] as any;
        if (ref) {
          let fieldValidity: boolean = ref.validate();
          validity = validity && fieldValidity;
        }
      });
    }
    return validity;
  }

  activated() {
    let focused = false;
    this.error = '';
    this.fields.forEach(field => {
      let input: any = this.refs()[field];
      if (input) {
        let invalid = !input.isValid();
        input.retouch();
        if (invalid && !input.value) input.resetValidation();
        if ((invalid || !input.value) && !focused) {
          // focus first empty or invalid field...
          input.focus();
          focused = true;
        }
      }
    });
    // ...or first inout at all
    if (!focused && this.fields.length) {
      (this.refs()[this.fields[0]] as InputElement)?.focus();
    }
  }

}

export default validateFormMixin
